import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import set from 'lodash/set'
import unset from 'lodash/unset'
import OLFormatGeoJSON from 'ol/format/GeoJSON'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziZoom from 'map/zoom'

export default function (geojson, projection, geojsonSource, layer) {
  // console.log('Refresh features...')

  if (!geojson || !geojson.features) {
    console.log('Invalid GeoJSON passed to refresh features!')
    return false
  }

  fixOldGeoServerGeoJSON(geojson)

  // Give format a geometry name that is unlikely to clash with potential feature
  // properties (like 'geometry' did in one case).
  // See OL bug report for this: https://github.com/openlayers/openlayers/issues/14220
  const format = new OLFormatGeoJSON({ geometryName: 'pozi_geometry_internal_representation' })
  const newFeatures = format.readFeatures(geojson, {
    featureProjection: projection
  })

  // console.debug('RefreshFeatures - new features', layer.titleid, newFeatures)

  // Manual differential of features (read vs. already on client)
  // var newFeatures = geojsonSource.readFeatures(data);
  const oldFeatures = geojsonSource.getFeatures()

  // console.debug('RefreshFeatures - old features', layer.titleid, oldFeatures)

  // Find ID, assumes all ids in a geojson are the same.
  let id = null
  if (geojson) {
    id = PoziUtils.findKeyInFeatureCollection(layer, geojson)
  }
  if (!id) {
    console.error('Unable to find an id for layer', layer.config)
    return false
  }

  // Array of feature IDs (new)
  const newIdArr = newFeatures.map((feature) => feature.get(id))

  // console.debug('RefreshFeatures - newIdArr', layer.titleid, id, [...newIdArr])

  // Array of feature IDs (old)
  const oldIdArr = oldFeatures.map((feature) => feature.get(id))

  // console.debug('RefreshFeatures - oldIdArr', layer.titleid, id, [...oldIdArr])

  // Step 1: identify the new features that were not in the old dataset, and add them
  // Note: if feature has no value for the ID, the feature will always be added as we have no simple way of comparing IDs.
  //       We would need to do a full feature comparison instead.
  for (const [i, v] of newIdArr.entries()) {
    if (!isNil(v) && oldIdArr.indexOf(v) === -1) {
      geojsonSource.addFeature(newFeatures[i])
    } else {
      // console.debug('Updated feature: not adding', layer.titleid, oldIdArr.indexOf(v), oldFeatures[oldIdArr.indexOf(v)], newFeatures[i])
    }
  }

  // Step 2: identify the old features that are not in the new dataset, and remove them
  // Note: if feature has no value for the ID, the feature will never be removed as we have no simple way of comparing IDs.
  //       We would need to do a full feature comparison instead.
  for (const [i, v] of oldIdArr.entries()) {
    if (!isNil(v) && newIdArr.indexOf(v) === -1) {
      // console.debug('Removing feature', layer.titleid, i, v, oldFeatures[i])
      geojsonSource.removeFeature(oldFeatures[i])
    }
  }

  const bFirstLoad = Model.get('app.donotserialise.bFirstLoad', true)
  const zoomDefined = Model.get('app.state.z', -1)
  if (layer.zoomExtents && bFirstLoad && zoomDefined === -1) {
    Model.set('app.donotserialise.bFirstLoad', false)
    const zoomPadding = 0
    const bSelectCenterPoint = false
    PoziZoom()
      .zoomToGeoJSON(geojson, zoomPadding, bSelectCenterPoint)
      .then(function () {
        console.log('Zoomed')
      })
      .catch(function (err) {
        console.error('Initial zoom', err)
      })
  }
}

var fixOldGeoServerGeoJSON = function (geojson) {
  const code = get(geojson, 'crs.properties.code', null)
  if (!isNil(code)) {
    console.log('OLD GeoServers export invalid geoJSON! Attempt to fix so OpenLayers works.')
    set(geojson, 'crs.properties.name', 'urn:ogc:def:crs:EPSG::' + code)
    set(geojson, 'crs.type', 'name')
    unset(geojson, 'crs.properties.code')
  }
  // console.log('fixOldGeoServerGeoJSON', geojson)
  /* var name = get(geojson, 'crs.properties.name', null)
    if (!isNil(name)) {
      if (name === 'urn:ogc:def:crs:OGC:1.3:CRS84') {
        set(geojson, 'crs.properties.name', 'urn:ogc:def:crs:EPSG::4326')
      }
    } */

  const features = get(geojson, 'features', [])
  for (const key in features) {
    const feature = features[key]
    if (!has(feature, 'type')) {
      set(geojson, 'features[' + key + '].type', 'Feature')
    }
  }

  return geojson
}
